import type { CalculateOffersPerson, Domain } from '@/services/inventory-api.service';
import type { ReferenceResortDomain, SkierCounts } from '@/store/book-ski-pass.store';
import {
  buildAgeMapFromRestrictions,
  buildBirthDateMapFromRestrictions,
  buildPeopleFromSkierCounts,
} from '@/utils/calculate-offers-people';

export function getDomainsToFetchIds(
  selectedDomain: Domain | null,
  referenceResortDomains: ReferenceResortDomain[] | null
): number[] {
  const domainIds = referenceResortDomains?.map((d) => d.id) ?? [];
  const selectedDomainId = selectedDomain?.pk;
  const shouldAddSelectedDomain =
    selectedDomainId != null && !domainIds.includes(selectedDomainId);
  if (domainIds.length > 0) {
    if (shouldAddSelectedDomain) {
      return [selectedDomainId, ...domainIds];
    }
    return domainIds;
  }
  return selectedDomainId != null ? [selectedDomainId] : [];
}

export function buildTripCalculatePeople(
  skierCounts: SkierCounts,
  startDate: string,
  days: number,
  restrictions: Domain['restrictions']
): CalculateOffersPerson[] {
  const ageMap = buildAgeMapFromRestrictions(restrictions);
  const birthDateMap = buildBirthDateMapFromRestrictions(restrictions, startDate);
  return buildPeopleFromSkierCounts(skierCounts, startDate, days, ageMap, birthDateMap);
}
